import * as React from 'react';
import {ViewerEvent} from '../events';
import {
    ConfigCallbackProps,
    configCallbackPropTypes,
    ConfigProps,
    configPropTypes,
    mapDefaultProps,
    MapProps,
    mapPropTypes,
    viewerDefaultProps,
    ViewerProps,
    viewerPropTypes,
} from './props';
import UnconnectedMapViewer from './UnconnectedMapViewer';
import connectBase from './connectBase';

/**
 * Mapový zobrazovač (varianta s konfigurací mapy na vstupu).
 * Interní skrytá implementace.
 *
 * @ignore
 */
const ConnectedBaseMapViewer = connectBase<ViewerProps, ViewerEvent>(UnconnectedMapViewer);

/**
 * Properties mapového zobrazovače (varianta s konfigurací mapy na vstupu).
 */
export type BaseMapViewerProps = MapProps<ViewerEvent> & ViewerProps & ConfigProps & ConfigCallbackProps;

/**
 * Mapový zobrazovač (varianta s konfigurací mapy na vstupu).
 *
 * @param props - Properties komponenty.
 * @returns Element.
 */
export default function BaseMapViewer(props: BaseMapViewerProps): JSX.Element {
    return <ConnectedBaseMapViewer debugName="BaseMapViewer" {...props} />;
}

/**
 * Typy properties.
 */
BaseMapViewer.propTypes = {
    ...mapPropTypes,
    ...viewerPropTypes,
    ...configPropTypes,
    ...configCallbackPropTypes,
};

/**
 * Výchozí hodnoty properties.
 */
BaseMapViewer.defaultProps = {
    ...mapDefaultProps,
    ...viewerDefaultProps,
};
